<template>
  <TarjetaDatos titulo="Mis datos">
    <Campo2L
      :valor="cliente.numDoc"
      etiqueta="Número de documento (NIF/CIF/NIE)"
    />
    <Campo2L :valor="cliente.nombre" etiqueta="Nombre" />
    <Campo2L :valor="cliente.direccion" etiqueta="Dirección" />
    <Campo2L :valor="cliente.telefono" etiqueta="Teléfono móvil" />
    <Campo2L :valor="cliente.email" etiqueta="E-mail" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    cliente: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
